import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 下方导航栏高度
    navH:0,
    userId:"",
    nickname:"",
    device:{}
  },
  getters: {

    getNavH: state => state.navH

} ,
  mutations: {
    setNavH(state,navH){
      state.navH = navH
    },
    setUserId(state,userId){
      state.userId = userId
    },
    setNickname(state,nickname){
      state.nickname = nickname
    },
    setDevice(state,device){
      state.device = device
    },
  },
  actions: {
  },
  modules: {
  }
})
